import WebUtils from "../../utils/WebUtils";

let baseUrl = WebUtils.getProctorBaseUrl();
let proctorPlatformBaseUrl = `${baseUrl}/proctor-platform/api/v1`;

export const getAllGuidesB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/getAllJobGuides`;
export const getQuestionBankTopicsApiB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/getQuestionTopics`;
export const getGuideDetailsB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/getJobGuide`;
export const getGuideContentApiB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/getJobGuideContent`;
export const getQuestionSkillListB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/getQuestionSkillList`;
export const getQuestionnaireB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/getQuestionnaire`;

//Practice
export const getJobSpecificFilterApiB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/specificQuestions/getAll`;
export const getSingleJobSpecificQuestionApiB2BCand = `${proctorPlatformBaseUrl}/b2b/candidate/specificQuestions/get`;

// Cv optimizer
export const getAllResumesApi = `${proctorPlatformBaseUrl}/cv/optimizer/getAllResumes`;
export const getResumeDataApi = `${proctorPlatformBaseUrl}/cv/optimizer/getResumeData`;
export const updateResumeDataApi = `${proctorPlatformBaseUrl}/cv/optimizer/updateResumeData`;
export const finalizeResumeFileApi = `${proctorPlatformBaseUrl}/cv/optimizer/saveResumeFile`;
export const createFromScratchApi = `${proctorPlatformBaseUrl}/cv/optimizer/saveDraft`;
export const viewResume = `${proctorPlatformBaseUrl}/cv/optimizer/viewResume`;
export const uploadResumeApi = `${proctorPlatformBaseUrl}/cv/optimizer/uploadResume`;
export const deleteResume = `${proctorPlatformBaseUrl}/cv/optimizer/deleteResume`;
export const getResumeDropDown = `${proctorPlatformBaseUrl}/cv/optimizer/getResumeDropDown`;
export const generateAiResumeContentApi = `${proctorPlatformBaseUrl}/cv/optimizer/reGenerateResumeContent`;
export const getResumeJdMatchDataApi = `${proctorPlatformBaseUrl}/cv/optimizer/getResumeJdMatchData`;
export const createAiRecommendedResumeApi = `${proctorPlatformBaseUrl}/cv/optimizer/createAiRecommendedResume`;

